/** Frameworks that expose per-attempt retry UI on the test cases table. */
export const FRAMEWORKS_WITH_RETRY_UI = ["playwright", "cucumber"];

export const supportsRetryColumn = (iteration, testCases) => {
  if (iteration?.framework && FRAMEWORKS_WITH_RETRY_UI.includes(iteration.framework)) {
    return true;
  }
  // Legacy Playwright iterations before framework field existed
  if (iteration?.flakyCount !== undefined) {
    return true;
  }
  // Cucumber iterations ingested before framework was persisted, but with retry data
  const cases = Array.isArray(testCases) ? testCases : [];
  return cases.some(
    (tc) =>
      (tc.retryCount ?? 0) > 0 &&
      Array.isArray(tc.retryAttempts) &&
      tc.retryAttempts.length > 0
  );
};
